import {
  BLOOD_GROUP_OPTIONS,
  EMAIL_PLACEHOLDER,
  MOBILE_PLACEHOLDER,
} from '@/constants/global.constants';
import { validateMobile } from '@/utils';
import { DatePicker, Form, Input, Select } from 'antd';
import dayjs from 'dayjs';

const { Option } = Select;

export default function PersonalInformation({ form }: any) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <Form.Item
        label={'Full Name'}
        name="name"
        rules={[
          {
            required: true,
            message: 'Full Name is required',
          },
        ]}
      >
        <Input placeholder="Full name" />
      </Form.Item>

      <Form.Item
        label="Phone Number"
        name="phone"
        rules={[
          { required: true, message: 'Phone Number is required' },
          { validator: validateMobile },
        ]}
        initialValue="+88"
      >
        <Input
          placeholder="01XXXXXXXXX"
          onChange={(e) => {
            const value = e.target.value;

            // Prevent deleting +88
            if (!value.startsWith('+88')) {
              form.setFieldsValue({ phone: '+88' });
            }
          }}
        />
      </Form.Item>

      <Form.Item
        label={'Email Address'}
        name="email"
        rules={[
          {
            required: true,
            message: 'Email Address is required',
          },
          { type: 'email', message: 'Please enter a valid email' },
        ]}
      >
        <Input placeholder={EMAIL_PLACEHOLDER} />
      </Form.Item>

      <Form.Item
        label={'Date of Birth'}
        name="date_of_birth"
        rules={[
          {
            validator: (_, value) => {
              // If no date selected → valid (optional field)
              if (!value) {
                return Promise.resolve();
              }

              // If selected date is in the future → error
              if (value.isAfter(dayjs(), 'day')) {
                return Promise.reject(
                  new Error('Date of birth cannot be a future date'),
                );
              }

              return Promise.resolve();
            },
          },
        ]}
      >
        <DatePicker
          showNow={false}
          placeholder="dd/mm/yyyy"
          format="DD/MM/YYYY"
          disabledDate={(current) => current && current > dayjs().endOf('day')}
        />
      </Form.Item>

      <Form.Item label={'Blood Group'} name="blood_group">
        <Select
          placeholder="Select Blood Group"
          className="bg-transparent border border-[#2b3b4b] rounded-md text-white"
        >
          {BLOOD_GROUP_OPTIONS.map((option) => (
            <Option key={option.value} value={option.value}>
              {option.label}
            </Option>
          ))}
        </Select>
      </Form.Item>

      <div className="col-span-2">
        <Form.Item
          label={'House Address'}
          name="house_address"
          // rules={[
          //   {
          //     required: true,
          //     message: "House Address is required",
          //   },
          // ]}
        >
          <Input placeholder={'e.g. Dhaka, Bangladesh'} />
        </Form.Item>
      </div>

      <div className="col-span-2">
        <Form.List name="emergency_contacts">
          {(fields) => (
            <>
              {fields.map(({ key, name, ...restField }) => (
                <div
                  key={key}
                  className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4"
                >
                  <Form.Item
                    {...restField}
                    label={'Emergency Contact Type'}
                    name={[name, 'relation']}
                    // rules={[
                    //   {
                    //     required: true,
                    //     message: "Emergency Type is required",
                    //   },
                    // ]}
                  >
                    <Select
                      placeholder="Select Relationship"
                      className="bg-transparent border border-[#2b3b4b] rounded-md text-white"
                    >
                      <Option value="spouse">Spouse</Option>
                      <Option value="parent">Parent</Option>
                      <Option value="friend">Friend</Option>
                    </Select>
                  </Form.Item>

                  <Form.Item
                    {...restField}
                    label={'Emergency Contact Name'}
                    name={[name, 'name']}
                    // rules={[
                    //   {
                    //     required: true,
                    //     message: "Emergency Contact Name is required",
                    //   },
                    // ]}
                  >
                    <Input placeholder="Full name" />
                  </Form.Item>

                  <Form.Item
                    {...restField}
                    label={'Emergency Contact Number'}
                    name={[name, 'mobile']}
                    rules={[
                      // {
                      //   required: true,
                      //   message: "Emergency Contact Number is required",
                      // },

                      { validator: validateMobile },
                    ]}
                  >
                    <Input placeholder={MOBILE_PLACEHOLDER} />
                  </Form.Item>

                  {/* <Form.Item label=" ">
                    <Button
                      type="link"
                      danger
                      onClick={() => remove(name)}
                      className="!text-red-500"
                    >
                      Remove
                    </Button>
                  </Form.Item> */}
                </div>
              ))}
              {/* <Form.Item>
                <Button
                  type="dashed"
                  onClick={() => add()}
                  block
                  className="!border-[#2b3b4b] !text-white"
                >
                  + Add Emergency Contact
                </Button>
              </Form.Item> */}
            </>
          )}
        </Form.List>
      </div>
    </div>
  );
}
